// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"4b084183","610":"f0858217","703":"195abb03","787":"ff99e58b"}[chunkId] + ".chunk.js";
};